import z from 'zod';
import { entity, string } from '../common';
export var RoleSubject;
(function (RoleSubject) {
    // Entity subjects
    RoleSubject["Alarm"] = "Alarm";
    RoleSubject["AlarmEvent"] = "AlarmEvent";
    RoleSubject["AlarmHelper"] = "AlarmHelper";
    RoleSubject["AlarmPushSubscription"] = "AlarmPushSubscription";
    RoleSubject["Asset"] = "Asset";
    RoleSubject["AssetGroup"] = "AssetGroup";
    RoleSubject["AuditLog"] = "AuditLog";
    RoleSubject["Beacon"] = "Beacon";
    RoleSubject["ContactList"] = "ContactList";
    RoleSubject["Customer"] = "Customer";
    RoleSubject["CustomerAlarmCenterRelation"] = "CustomerAlarmCenterRelation";
    RoleSubject["CustomerUserRelation"] = "CustomerUserRelation";
    RoleSubject["Device"] = "Device";
    RoleSubject["Observation"] = "Observation";
    RoleSubject["ObservationTrigger"] = "ObservationTrigger";
    RoleSubject["Overlay"] = "Overlay";
    RoleSubject["ReportTrigger"] = "ReportTrigger";
    RoleSubject["ReportTriggerRun"] = "ReportTriggerRun";
    RoleSubject["Role"] = "Role";
    RoleSubject["StaticResponder"] = "StaticResponder";
    RoleSubject["Webhook"] = "Webhook";
    RoleSubject["User"] = "User";
    RoleSubject["Zone"] = "Zone";
    RoleSubject["Fingerprint"] = "Fingerprint";
    // Non-entity subjects
    RoleSubject["Report"] = "Report";
    // Special subjects
    RoleSubject["All"] = "all";
})(RoleSubject || (RoleSubject = {}));
export var RequestMode;
(function (RequestMode) {
    RequestMode["default"] = "default";
    RequestMode["asUser"] = "asUser";
})(RequestMode || (RequestMode = {}));
export const permissionLimit = z.object({
    connectedCustomers: z.boolean().optional(),
    connectedCustomersViaRelation: z.boolean().optional(),
    alarmsEscalatedToMyAlarmCenter: z.boolean().optional(),
    alarmAgeLimitOfCustomer: z.boolean().optional(),
    ownUserId: z.boolean().optional(),
    ownAssetId: z.boolean().optional(),
    mode: z.nativeEnum(RequestMode).optional(),
    fields: string.array().optional(),
    allowedRoles: string.array().optional(),
});
export const permission = z.object({
    subject: z.nativeEnum(RoleSubject),
    actions: string.array(),
    limit: permissionLimit.optional(),
});
export const role = z.object({
    ...entity.shape,
    name: string,
    permissions: permission.array(),
});
